import React from "react";
import { Link, NavLink } from "react-router-dom";
import { MdDashboard, MdOutlineAddCircleOutline } from "react-icons/md";
import logo from "../../assets/logo.png";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="flex-shrink-0 dashboard_sidebar sidebar">
        <div className="logo">
          <Link className="simple-text">
            <div className="logo-img">
              <img src={logo} alt="logo" className="img" />
            </div>
          </Link>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav p-0">
            <li className="nav-item">
              <NavLink to={"/"} className="nav-link">
                <MdDashboard className="icons" /> Dashboard
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to={"/apply-campaigns"} className="nav-link">
                <MdOutlineAddCircleOutline className="icons" /> Apply Campaign
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
